import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import security from "../../services/security.js";
import events from "../../services/events.js";
import env from "../../services/env.js";

class JobcontactController {
  constructor(
    $http,
    $localStorage,
    $state,
    AuthService,
    $rootScope,
    $scope,
    SecurityService,
    EventsService,
    EnvService,
    $timeout,
    TrackingService,
    CompaniesService
  ) {
    this.name = "jobcontact";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$rootScope = $rootScope;
    this.$security = SecurityService;
    this.$events = EventsService;
    this.$companies = CompaniesService;
    this.$scope = $scope;
    this.$env = EnvService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.currentUser = this.$auth.getUserData();
    //this.hiring_manager = 2106;
    this.remain_loading_count = 0;

    var _this = this;

    if (!_this.$state.params.eventId && _this.currentUser) {
      _this.getCompanyUsers();
    }

    _this.SetManagerForEditPageListener = _this.$rootScope.$on("SetManagerForEditPage", function ($event, data) {
      console.log("SetManagerForEditPageListener");
      console.dir(data);
      let manager = data.id;
      _this.on_edit_page = true;
      _this.getCompanyUsers(manager);
    });

    _this.SetManagerFromBackListener = _this.$rootScope.$on("SetManagerFromBack", function ($event, data) {
      let manager = data.id;
      _this.getCompanyUsers(manager);
    });

    _this.$scope.$on("$destroy", _this.SetManagerForEditPageListener);
    _this.$scope.$on("$destroy", _this.SetManagerFromBackListener);
  }

  getCompanyUsers(manager) {
    var _this = this;
    _this.$companies.getCompanyUsers().then(
      function (response) {
        _this.constructOptions(response.data, manager);
      },
      function (error) {}
    );
  }

  constructOptions(users, manager) {
    var _this = this;

    let user_array = [];

    if (manager) {
      _this.id_for_backend = manager;
    }

    users.forEach(function (user) {
      let user_map = {};

      if (user.homeContactInfo.phoneMobile) {
        user_map.firstName = user.firstName;
        user_map.lastName = user.firstName;
        user_map.phone = user.homeContactInfo.phoneMobile;
        user_map.id = user.id;
        user_map.str = user.firstName + " " + user.lastName;
        user_map.email = user.email;
        user_array.push(user_map);
      } else {
        user.homeContactInfo.phoneMobile = "--";
        user_map.firstName = user.firstName;
        user_map.lastName = user.firstName;
        user_map.phone = user.homeContactInfo.phoneMobile;
        user_map.id = user.id;
        user_map.str = user.firstName + " " + user.lastName;
        user_map.email = user.email;
        user_array.push(user_map);
      }
    });

    _this.contact_options = {values: user_array};

    console.log("contact_options");
    console.dir(_this.contact_options);
  }

  managerChanged() {
    var _this = this;

    if (_this.on_edit_page) {
      _this.$rootScope.$broadcast("SetOnSiteManagerEdit", {
        data: _this.id_for_backend,
      });
    } else {
      _this.$rootScope.$broadcast("SetOnSiteManager", {
        data: _this.id_for_backend,
      });
    }
  }

  setManagerForEditPage(user) {
    var _this = this;

    let user_map_selected = {};
    let user_map_selected_array = [];
    let user_array = [];

    user_map_selected.firstName = user.firstName;
    user_map_selected.lastName = user.firstName;
    user_map_selected.phone = user.homeContactInfo.phoneMobile;
    user_map_selected.id = user.id;
    user_map_selected.str = user.firstName + " " + user.lastName;
    user_map_selected.email = user.email;
    user_map_selected_array.push(user_map_selected);

    _this.users.forEach(function (user) {
      let user_map = {};
      if (user.homeContactInfo.phoneMobile) {
        user_map.firstName = user.firstName;
        user_map.lastName = user.firstName;
        user_map.phone = user.homeContactInfo.phoneMobile;
        user_map.id = user.id;
        user_map.str = user.firstName + " " + user.lastName;
        user_map.email = user.email;
        user_array.push(user_map);
      }
    });
    _this.users_array_final = user_array;
    _this.selected_user = user_map_selected_array;
  }
}

JobcontactController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "$rootScope",
  "$scope",
  "security",
  "events",
  "env",
  "$timeout",
  "tracking",
  "companies",
];

export default JobcontactController;



// WEBPACK FOOTER //
// ./client/app/common/jobcontact/jobcontact.controller.js